
export default class ContentTypeForAutoImportConfigDTO {
    constructor(dto) {
        this.id = 0;
        this.name = '';
        this.description = '';
        this.majVersion = 0;
        this.minVersion = 0;
        this.isLastVersion = false;
        this.organizationID = 0;
        this.organizationName = '';
        this.encryptDocuments = false;
        this.hasAutomaticRecognition = false;
        this.defFields = [];
        this.hasDocuments = false;
        this.keepActualVersion = false;
        this.version = 'v1.0';
        if (dto) {
            Object.assign(this, dto, {
                encryptDocuments: dto.encryptDocuments || false,
            });
        }
    }
}